module.exports = __webpack_public_path__ + "img/newRetail-1f-img2.8d9735bc.png";